import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Grid, Row, Column } from '@lux/components';
import { BodyPrimary, BodySecondary } from '../Base';
import Modal from '../Modal';

import IconInfo from '../../assets/svgs/info.svg';

const StyledPromoStrip = styled.div`
  padding: ${p => p.theme.spacing(1.5)} 0;
  background-color: ${p => p.theme.colours.yellow_900};
  ${p =>
    p.enableSecondaryStrip &&
    css`
      cursor: pointer;
    `};
`;

const StyledPrimaryLiner = styled.span`
  margin-right: ${p => p.theme.spacing(1)};
`;

const StyledIconInfo = styled(IconInfo)`
  margin-top: -2px;
  vertical-align: middle;
`;

const PromoStrip = props => {
  const { enableSecondaryStrip, primaryLiner, modalContent } = props;

  const [openPromoStripModal, setOpenPromoStripModal] = useState(false);

  return (
    <Fragment>
      <StyledPromoStrip
        enableSecondaryStrip={enableSecondaryStrip}
        onClick={() => enableSecondaryStrip && setOpenPromoStripModal(true)}
      >
        <Grid>
          <Row middle="sm">
            <Column>
              <BodyPrimary>
                <StyledPrimaryLiner>{primaryLiner}</StyledPrimaryLiner>
                {enableSecondaryStrip && (
                  <StyledIconInfo data-testid="icon-info" />
                )}
              </BodyPrimary>
            </Column>
          </Row>
        </Grid>
      </StyledPromoStrip>
      {enableSecondaryStrip && (
        <Modal
          open={openPromoStripModal}
          title={modalContent.mainTitle}
          onClose={() => setOpenPromoStripModal(false)}
        >
          <BodySecondary>{modalContent.sectionTitle}</BodySecondary>
          <BodySecondary
            dangerouslySetInnerHTML={{
              __html: modalContent.sectionDescription
            }}
          />
          <BodySecondary
            dangerouslySetInnerHTML={{ __html: modalContent.sectionFooter }}
          />
        </Modal>
      )}
    </Fragment>
  );
};

PromoStrip.propTypes = {
  /* Set the primary line for the promo strip */
  primaryLiner: PropTypes.string,
  /* Enable or disable the modal content */
  enableSecondaryStrip: PropTypes.bool,
  /* Set the modal content */
  modalContent: PropTypes.shape({
    mainTitle: PropTypes.string,
    sectionDescription: PropTypes.node,
    sectionFooter: PropTypes.node
  })
};

export default PromoStrip;
